<svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M1.375 1.81098V12.5C1.375 14.1569 2.71815 15.5 4.375 15.5H15.625C17.2819 15.5 18.625 14.1569 18.625 12.5V5.93902C18.625 4.28217 17.2819 2.93902 15.625 2.93902H2.59451C1.92099 2.93902 1.375 2.39303 1.375 1.71951V1.71951C1.375 1.04599 1.92099 0.5 2.59451 0.5H12.7037C14.0107 0.5 15.0703 1.55957 15.0703 2.86662V2.86662"
        stroke="var(--bg-color)" />
    <path
        d="M18.625 7.33691H15.1688C14.1522 7.33691 13.3281 8.16102 13.3281 9.17762V9.17762C13.3281 10.1942 14.1522 11.0183 15.1688 11.0183H18.625"
        stroke="var(--bg-color)" />
</svg>
